/*
 * Constants.
 */

export const splashHiddenMetric = 'splashHidden';
export const nativeLaunchMetric = 'nativeLaunch';
